const GRAMMAR_ARTICLES = [
  "a",
  "an",
  "and",
  "as",
  "at",
  "but",
  "by",
  "etc",
  "for",
  "in",
  "into",
  "is",
  "nor",
  "of",
  "off",
  "on",
  "onto",
  "or",
  "so",
  "the",
  "to",
  "unto",
  "via"
];

export const startCase = (str: string): string => {
  if (!str) {
    return str;
  }

  let convertedStr = str.toLowerCase().split(" ");
  for (let i = 0; i < convertedStr.length; i++) {
    convertedStr[i] =
      convertedStr[i].charAt(0).toUpperCase() + convertedStr[i].slice(1);
  }
  return convertedStr.join(" ");
};

export function capitalize(str: string): string {
  return str
    .toLowerCase()
    .split(" ")
    .map(word =>
      GRAMMAR_ARTICLES.includes(word)
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(" ");
}
